module.exports = __webpack_public_path__ + "img/lining.0628f71c.jpg";